import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

function customInputsAddonGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (store.getters['subscription/isCustomInputsPurchased']) {
    return next()
  }
  return next({ name: 'error-404' })
}

export default customInputsAddonGuard
